module.exports = __webpack_public_path__ + "assets/img/1311587607084_.pic_hd.6ee5d0be.jpg";